import { apiCrm } from '../../../../http';

class SchedulingCrmService {
  async createScheduleCrm(data) {
    return apiCrm.post(`/crm-schedule/create`, data);
  }

  async cancelScheduleCrm(schedulingId) {
    return apiCrm.delete(`/crm-schedule/cancel/${schedulingId}`);
  }

  async getScheduleByIdCrm(schedulingId) {
    return apiCrm.get(`/crm-schedule/${schedulingId}`);
  }

  async rescheduleSchedulingCrm(schedulingId, data) {
    return apiCrm.put(`/crm-schedule/reschedule/${schedulingId}`, data);
  }
}

export default new SchedulingCrmService();
